import { initRecaptcha } from "xart-utils";

initRecaptcha()